// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules_dev/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".col-lg-3 ul{list-style-type:none;padding-left:10px}.chapters>li+li{margin-top:10px}.chapter-title{font-size:16px}.katex-html{display:none}.course-content h2{font-size:32px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
